export const MAX_AMOUNT_FOR_PAYMENT = 6000;
